import React, {useContext, useEffect, useState} from "react";
import styles from "./metrics/Metrics.module.scss";
import SelectBox from "../../../../Componnets/SelectBox/SelectBox";
import Button from "../../../../Componnets/Button/Button";
import appContext from "../../../../../context/appContext";

const Metrics = ({selectedItems, onChangeMetrics, handleAddNewFilter, themeColor}) => {

  const [canCalculateAutomatically, setCanCalculateAutomatically] = useState(true)
  const [metricsValues, setMetricsValues] = useState([{
    column: undefined,
    operand: undefined,
    value: undefined
  }])
  const [time, setTime] = useState({
    startTime: {
      year: 0,
      day: 0,
      hour: 0,
      minute: 0
    },
    endTime: {
      year: 0,
      day: 0,
      hour: 0,
      minute: 0
    }
  })

  const metricsData = ["tpt", "event_count", "loop", "self_loop"];

  const metricsMap = {
    tpt: "Throughput Time",
    // activeTime: "Active Time",
    event_count: "Event Count",
    loop: "Loop Count",
    self_loop: "Self-Loop Count",
    // reworkCount: "Rework Count",
    // cost: "Cost"
  }

  useEffect(() => {
    if (!selectedItems?.data?.length) {
      const initialValues = [{
        column: "Column",
        operand: "Operator",
        value: "Value",
        is_active: true
      }]
      onChangeMetrics(initialValues)
      setMetricsValues(initialValues)
    }
  }, [])

  const convertSecondsToTimeParameters = (value) => {
    if (canCalculateAutomatically) {
      const aYear = 31536000
      const aDay = 86400
      const anHour = 3600
      const aMinute = 60

      const year = Math.floor(value / aYear) || 0
      const day = Math.floor((value - year * aYear) / aDay) || 0;
      const hour = Math.floor((value - year * aYear - day * aDay) / anHour) || 0;
      const minute = Math.floor((value - year * aYear - day * aDay - hour * anHour) / aMinute) || 0;

      return {
        year,
        day,
        hour,
        minute
      }
    } else {
      return false
    }
  }

  const calculateTimeFromSeconds = () => {
    let copyOfSelectedItemsData = selectedItems?.data
    let value = copyOfSelectedItemsData[copyOfSelectedItemsData.length - 1].value
    if (copyOfSelectedItemsData.length && copyOfSelectedItemsData[copyOfSelectedItemsData.length - 1].column === "tpt") {
      if (copyOfSelectedItemsData[copyOfSelectedItemsData.length - 1].operand === "<>") {
        const startTime = convertSecondsToTimeParameters(value[0])
        const endTime = convertSecondsToTimeParameters(value[1])
        const time = {startTime: {...startTime}, endTime: {...endTime}}
        setTime(time)
      } else {
        const startTime = convertSecondsToTimeParameters(value)
        setTime({startTime, ...time})
      }
    }
  }

  useEffect(() => {
    if (selectedItems?.data?.length) {
      let copyOfSelectedItemsData = selectedItems?.data
      calculateTimeFromSeconds()
      setMetricsValues(copyOfSelectedItemsData)
    }
  }, [])

  const allowedOperators = {
    tpt: [
      {
        display: "=",
        data: "="
      },
      {
        display: "!=",
        data: "!="
      },
      {
        display: "~",
        data: "~",
      },
      {
        display: ">",
        data: ">"
      },
      {
        display: "<",
        data: "<",
      },
      {
        display: ">=",
        data: ">="
      },
      {
        display: "<=",
        data: "<="
      },
      {
        display: "range",
        data: "<>"
      }
    ]
  }

  useEffect(() => {
    if (selectedItems?.data?.length) {
      setMetricsValues(selectedItems.data)
    }
  }, [selectedItems])

  const handleSelectMetric = (value, type, isRange = false, isCalculatedBefore = false, timer) => {
    let copyOfMetricsValues = [...metricsValues]
    if (type !== "operand" && type !== "column" && !isCalculatedBefore) {
      if (isRange) {
        if (Array.isArray(copyOfMetricsValues[copyOfMetricsValues.length - 1]?.value)) {
          copyOfMetricsValues[copyOfMetricsValues.length - 1][type] = [copyOfMetricsValues[copyOfMetricsValues.length - 1].value[0], value]
        } else {
          copyOfMetricsValues[copyOfMetricsValues.length - 1][type] = [copyOfMetricsValues[copyOfMetricsValues.length - 1].value, value]
        }
      } else {
        if (Array.isArray(copyOfMetricsValues[copyOfMetricsValues.length - 1]?.value)) {
          copyOfMetricsValues[copyOfMetricsValues.length - 1][type] = [value, copyOfMetricsValues[copyOfMetricsValues.length - 1].value[1]]
        } else {
          copyOfMetricsValues[copyOfMetricsValues.length - 1][type] = value
        }
      }
    } else {
      copyOfMetricsValues[copyOfMetricsValues.length - 1][type] = value
    }

    if (type === "operand" && copyOfMetricsValues[copyOfMetricsValues.length - 1].value !== "Value") {
      if (copyOfMetricsValues[copyOfMetricsValues.length - 1].operand !== "<>") {
        if (Array.isArray(copyOfMetricsValues[copyOfMetricsValues.length - 1].value)) {
          copyOfMetricsValues[copyOfMetricsValues.length - 1].value = copyOfMetricsValues[copyOfMetricsValues.length - 1].value[0]
          setTime({...time, endTime: {year: 0, day: 0, minute: 0, hour: 0}})
        }
      } else {
        copyOfMetricsValues[copyOfMetricsValues.length - 1].value = [copyOfMetricsValues[copyOfMetricsValues.length - 1].value, 0]
      }
    }

    if (copyOfMetricsValues[copyOfMetricsValues.length - 1].value === "") {
      copyOfMetricsValues[copyOfMetricsValues.length - 1].value = 0
    }

    if ((!copyOfMetricsValues[copyOfMetricsValues.length - 1].value) ||
      (copyOfMetricsValues[copyOfMetricsValues.length - 1].column &&
        copyOfMetricsValues[copyOfMetricsValues.length - 1].operand &&
        copyOfMetricsValues[copyOfMetricsValues.length - 1].value &&
        copyOfMetricsValues[copyOfMetricsValues.length - 1].value !== "Value")) {
          delete copyOfMetricsValues[copyOfMetricsValues?.length - 1]?.addMore;
          copyOfMetricsValues[copyOfMetricsValues.length - 1].is_active = true
          clearTimeout(window.typingTimer);
          if (timer) {
            window.typingTimer = setTimeout(() => onChangeMetrics(copyOfMetricsValues), 1000);
          } else {
            onChangeMetrics(copyOfMetricsValues)
          }
    }
    setMetricsValues(copyOfMetricsValues)
  }

  const handleChangeValue = (value, type, range) => {
    setCanCalculateAutomatically(false)
    let copyOfTime = {...time}
    switch (type) {
      case "year":
        copyOfTime = {...copyOfTime, [range]: {...time[range], year: (value * 365) * 24 * 60 * 60}}
        break
      case "day":
        copyOfTime = {...copyOfTime, [range]: {...time[range], day: value * 24 * 60 * 60}}
        break
      case "hour":
        copyOfTime = {...copyOfTime, [range]: {...time[range], hour: value * 60 * 60}}
        break
      case "minute":
        copyOfTime = {...copyOfTime, [range]: {...time[range], minute: value * 60}}
        break
      default:
        return false
    }

    let calculatedToSecondsValue = copyOfTime[range].year + copyOfTime[range].day + copyOfTime[range].hour + copyOfTime[range].minute
    if (metricsValues[metricsValues.length - 1]?.operand === "<>") {
      calculatedToSecondsValue = [
        copyOfTime?.startTime?.year + copyOfTime?.startTime?.day + copyOfTime?.startTime?.hour + copyOfTime?.startTime?.minute,
        copyOfTime?.endTime?.year + copyOfTime?.endTime?.day + copyOfTime?.endTime?.hour + copyOfTime?.endTime?.minute
      ]
    }

    handleSelectMetric(calculatedToSecondsValue, "value", false, true, true)
    setTime(copyOfTime)
  }

  const context = useContext(appContext);

  const selectBoxStyle = {
    padding: "10px 16px",
    width: 325,
    height: 40,
    background: "#F0F2FF",
    border: 0,
    borderRadius: 13
  }

  const handleAddNew = () => {
    handleAddNewFilter("addMore", "metrics");
  }

  const copyOfSelectedItemsData = selectedItems?.data
  const value = copyOfSelectedItemsData && copyOfSelectedItemsData.length && copyOfSelectedItemsData[copyOfSelectedItemsData.length - 1].value
  const operand = copyOfSelectedItemsData && copyOfSelectedItemsData.length && copyOfSelectedItemsData[copyOfSelectedItemsData.length - 1].operand
  const column = copyOfSelectedItemsData && copyOfSelectedItemsData.length && copyOfSelectedItemsData[copyOfSelectedItemsData.length - 1].column

  return (
    <div className={styles.Metrics}>
      <div className={styles.title}>
        Metrics
      </div>
      <div className={'d-flex justify-content-between'}>
        <div className={styles.content}>
          <div className={styles.dropdown}>
            <SelectBox
              dropDownValue={metricsValues[metricsValues.length - 1]?.column !== "Column" ?
                <span>{metricsValues[metricsValues.length - 1]?.column}</span> : 'Select Metrics...'}
              style={selectBoxStyle}
              arrow={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.6667 5.66675L8 10.3334L3.33333 5.66675" stroke="#200E32" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              }
            >
              {
                metricsData && metricsData.length && metricsData.map(option => (
                  <div
                    onClick={() => handleSelectMetric(option, "column")}
                    // className={sidebarDataIds.includes(option.id) && styles.disabled}
                  >
                    {metricsMap[option]}
                  </div>
                ))
              }
            </SelectBox>
          </div>
          <div className={styles.operators}>
            {
              metricsValues[metricsValues.length - 1]?.column !== "Column" &&
              allowedOperators.tpt.map(item =>
                <span
                  onClick={() => handleSelectMetric(item.data, "operand")}
                  style={{maxWidth: item.data === "<>" && "unset", padding: item === "<>" && "15px 24px 14px 24px", backgroundColor: metricsValues[metricsValues.length - 1]?.operand === item.data && themeColor && themeColor }}
                  className={`d-inline-flex align-items-center justify-content-center ${metricsValues[metricsValues.length - 1]?.operand === item.data && styles.selected}`}
                >
                  {item.display}
                </span>)
            }
          </div>
          {
            metricsValues[metricsValues.length - 1]?.operand !== "Operator" &&
            (metricsValues[metricsValues.length - 1]?.column === "tpt" || metricsValues[metricsValues.length - 1]?.column === "activeTime") &&
            <div className={styles.value}>
              <div className={styles.valueTitle}>
                Value
              </div>
              <div className={'d-flex'}>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="year"
                         value={(operand === "<>" && value[0]) ? convertSecondsToTimeParameters(value[0])?.year : convertSecondsToTimeParameters(value)?.year}
                         onChange={(e) => handleChangeValue(e.target.value, "year", "startTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>Y</span>
                </div>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="day"
                         value={(operand === "<>" && value[0]) ? convertSecondsToTimeParameters(value[0])?.day : convertSecondsToTimeParameters(value)?.day}
                         onChange={(e) => handleChangeValue(e.target.value, "day", "startTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>D</span>
                </div>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="hour"
                         value={(operand === "<>" && value[0]) ? convertSecondsToTimeParameters(value[0])?.hour : convertSecondsToTimeParameters(value)?.hour}
                         onChange={(e) => handleChangeValue(e.target.value, "hour", "startTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>H</span>
                </div>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="minute"
                         value={(operand === "<>" && value[0]) ? convertSecondsToTimeParameters(value[0])?.minute : convertSecondsToTimeParameters(value)?.minute}
                         onChange={(e) => handleChangeValue(e.target.value, "minute", "startTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>M</span>
                </div>
              </div>
            </div>
          }
          {
            metricsValues[metricsValues.length - 1]?.operand !== "Operator" &&
            (metricsValues[metricsValues.length - 1]?.column === "tpt" || metricsValues[metricsValues.length - 1]?.column === "activeTime") &&
            metricsValues[metricsValues.length - 1]?.operand === "<>" &&
            <div className={styles.value}>
              <div className={styles.to} style={{color: themeColor}}>
                To
              </div>
              <div className={styles.valueTitle}>
                Value
              </div>
              <div className={'d-flex'}>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="year"
                         value={(operand === "<>" && value[1]) ? convertSecondsToTimeParameters(value[1])?.year : null}
                         onChange={(e) => handleChangeValue(e.target.value, "year", "endTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>Y</span>
                </div>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="day"
                         value={(operand === "<>" && value[1]) ? convertSecondsToTimeParameters(value[1])?.day : null}
                         onChange={(e) => handleChangeValue(e.target.value, "day", "endTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>D</span>
                </div>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="hour"
                         value={(operand === "<>" && value[1]) ? convertSecondsToTimeParameters(value[1])?.hour : null}
                         onChange={(e) => handleChangeValue(e.target.value, "hour", "endTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>H</span>
                </div>
                <div className={`d-flex ${styles.inputContainer}`}>
                  <input className={styles.inputField} type="text" placeholder="0" name="minute"
                         value={(operand === "<>" && value[1]) ? convertSecondsToTimeParameters(value[1])?.minute : null}
                         onChange={(e) => handleChangeValue(e.target.value, "minute", "endTime")}/>
                  <span className={`d-flex align-items-center justify-content-center ${styles.icon}`}>M</span>
                </div>
              </div>
            </div>
          }
          {
            metricsValues[metricsValues.length - 1]?.operand !== "Operator" && (metricsValues[metricsValues.length - 1]?.column !== "tpt" && metricsValues[metricsValues.length - 1]?.column !== "activeTime" && metricsValues[metricsValues.length - 1]?.column !== "Column") &&
            <div className={styles.value}>
              <div className={styles.valueTitle}>
                Value
              </div>
              <div className={'d-flex'}>
                <div className={`d-flex ${styles.inputContainer} ${styles.simpleValue}`}>
                  <input className={styles.inputField} type="text" placeholder="0"
                         value={(metricsValues?.length && metricsValues[metricsValues.length - 1]?.value !== "Value") ? (Array.isArray(metricsValues[metricsValues.length - 1]?.value) ? metricsValues[metricsValues.length - 1]?.value[0] : metricsValues[metricsValues.length - 1]?.value) : null}
                         onChange={(e) => handleSelectMetric(+e.target.value, "value", null, null, true)}
                  />
                </div>
              </div>
            </div>
          }
          {
            metricsValues[metricsValues.length - 1]?.operand !== "Operator" && metricsValues[metricsValues.length - 1]?.operand === "<>" && (metricsValues[metricsValues.length - 1]?.column !== "tpt" && metricsValues[metricsValues.length - 1]?.column !== "activeTime" && metricsValues[metricsValues.length - 1]?.column !== "Column") &&
            <div className={styles.value}>
              <div className={styles.to} style={{color: themeColor}}>
                To
              </div>
              <div className={styles.valueTitle}>
                Value
              </div>
              <div className={'d-flex'}>
                <div className={`d-flex ${styles.inputContainer} ${styles.simpleValue}`}>
                  <input className={styles.inputField} type="text" placeholder="0"
                         value={(metricsValues?.length && metricsValues[metricsValues.length - 1]?.value !== "Value") ? metricsValues[metricsValues.length - 1]?.value[1] : null}
                         onChange={(e) => handleSelectMetric(+e.target.value, "value", true, null, true)}
                  />
                </div>
              </div>
            </div>
          }
        </div>
        <div className={[styles.buttons, 'd-flex'].join(' ')}>
          <div className={'mr-2'}>
            <Button
              onClick={handleAddNew}
              title={'Add More'}
              color={context?.handleLayerList().find(item => item.selected)?.color}
              type={'outline'}
              size={'block'}
              height={"medium"}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Metrics;